import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../consts/table';
import { DEFAULT_FILTER } from '../admin/user';
import { Count } from '../../../models/count';
import { TournamentWaitingListItem } from '../../../models/tournamentWaitingList';

export function getTournamentWaitingList(
  user: AppUser,
  tournamentId: string,
  filter = DEFAULT_FILTER
): Promise<TournamentWaitingListItem[]> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios
    .get<TournamentWaitingListItem[]>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/waitingList`,
      config
    )
    .then(response => response.data);
}

export function getTournamentWaitingListCount(user: AppUser, tournamentId: string, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config =
    typeof where !== 'undefined'
      ? {
          headers: { usid: key },
          params: {
            filter: {
              where
            }
          }
        }
      : {
          headers: { usid: key }
        };

  return axios
    .get<Count>(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/waitingList/count`, config)
    .then(response => response.data);
}

export function getAllTournamentWaitingList(
  user: AppUser,
  tournamentId: string,
  where?
): Promise<TournamentWaitingListItem[]> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config =
    typeof where !== 'undefined'
      ? {
          headers: { usid: key },
          params: {
            filter: {
              where: {
                ...where
              },
              limit: DEFAULT_LIMIT,
              skip: DEFAULT_SKIP
            }
          }
        }
      : {
          headers: { usid: key },
          params: {
            filter: {
              limit: DEFAULT_LIMIT,
              skip: DEFAULT_SKIP
            }
          }
        };

  return axios
    .get<TournamentWaitingListItem[]>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/waitingList`,
      config
    )
    .then(response => response.data);
}

export function addTournamentWaitingListSchool(
  user: AppUser,
  tournamentId: string,
  schoolId: string
): Promise<TournamentWaitingListItem> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post<TournamentWaitingListItem>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/waitingList`,
      { schoolId },
      config
    )
    .then(response => response.data);
}

export function removeTournamentWaitingListSchool(
  user: AppUser,
  tournamentId: string,
  schoolId: string
): Promise<TournamentWaitingListItem[]> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post<TournamentWaitingListItem[]>(
      `${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/waitingList/remove`,
      { schoolId },
      config
    )
    .then(response => response.data);
}
